import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { urls, strings, CONTAS } from './../../../../../environments/environment';
import * as md5 from 'blueimp-md5';
import { LocalStorageService } from './../../local-storage/local-storage.service';
import { Observable } from 'rxjs';
import { AuthorizationData, IChangePassword } from './login.interface';

@Injectable()
export class LoginService {
  headers: HttpHeaders;

  constructor(
    private http: HttpClient,
    private router: Router,
    private localStorageService: LocalStorageService
  ) { }

  addHeaders() {
    this.headers = new HttpHeaders();
    const loginObject = this.localStorageService.get('login');
    this.headers = this.headers.set('Authorization', 'Bearer ' + loginObject.Token);
  }

  login(email, password): Observable<AuthorizationData> {
    const data = {
      Email: email,
      AppSource: 'paguela',
      Password: md5(email + password),
    };

    return this.http
      .post(urls.user_service + '/Auth/Login', data);
  }

  refreshToken(refreshToken) {
    const data = {
      token: refreshToken,
      AppSource: 'paguela',
    };

    return this.http
      .post(urls.user_service + '/Auth/Refresh', data);
  }

  logOut() {
    this.localStorageService.set('login', null);
    this.router.navigate(['/login']);
  }

  getUserData() {
    return this.http
      .get(urls.apiBaseActuar + '/accoounts/user', { withCredentials: true });
  }

  public changePassword(data: IChangePassword): Observable<any> {
    this.addHeaders();

    return this.http
      .post(`${urls.user_service}/Auth/ChangePassword`, data, {
        headers: this.headers,
        withCredentials: false
    });
  }

  isAdmin(): boolean {
    const loginData = this.localStorageService.get('login');
      if (loginData.PersonId) {
       return loginData.PersonId === CONTAS.ACTUAR_CONTAID ||
              loginData.PersonId === CONTAS.TOLETUS_CONTAID ||
              loginData.PersonId === CONTAS.PAGUELA_CONTAID;
      }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth/login/login.service.ts